// extracted by mini-css-extract-plugin
module.exports = {"map":"YMap_map__1N3oe"};